module.exports = __webpack_public_path__ + "@/assets/img/spy.e5010d6a.svg";